import styled from 'styled-components';

export default styled.li`
  font-family: ${({
    theme: {
      fonts: { main },
    },
  }) => main};
  font-size: ${({
    theme: {
      fontSizes: { paragraph },
    },
  }) => paragraph};
  color: ${({
    theme: {
      colors: { bodyFg },
    },
  }) => bodyFg};
  line-height: 100%;
  margin: ${({ theme: { spacingBase } }) => spacingBase} 0;
  font-weight: 400;

  b {
    font-weight: 900;
  }
`;
